import {Decoder, field, number, object, string} from 'json-bouncer'
import * as ProductCategory from './ProductCategory'

export interface Product {
    readonly productId: number
    readonly externalProductId: string
    readonly name: string
    readonly category: ProductCategory.ProductCategory
    readonly weight: number
    readonly packingQuantity: number
}

export function productDecoder(): Decoder<Product> {
    return object({
        productId: field('productId', number()),
        externalProductId: field('externalProductId', string()),
        name: field('name', string()),
        category: field('category', ProductCategory.decoder()),
        weight: field('weight', number()),
        packingQuantity: field('packingQuantity', number()),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/Product.ts